class Slider {
    constructor(selector = '.el-images', options = {}) {
        this.$wrappers = $(selector);

        this.defaults = {
            slidesToShow: 6,
            infinite: true,
            arrows: true,
            prevArrow: (typeof prevArrow !== 'undefined') ? prevArrow : null,
            nextArrow: (typeof nextArrow !== 'undefined') ? nextArrow : null,

            // Standard (nicht marquee)
            autoplay: true,
            autoplaySpeed: 2500,
            speed: 600,
            cssEase: 'ease',

            pauseOnHover: true,
            pauseOnFocus: true,
            pauseOnDotsHover: true,

            swipe: true,
            draggable: true,
            touchMove: true,

            responsive: [
                { breakpoint: 1024, settings: { slidesToShow: 4 } },
                { breakpoint: 768, settings: { slidesToShow: 2 } }
            ]
        };

        this.options = Object.assign({}, this.defaults, options);
        this.init();
    }

    init() {
        this.$wrappers.each((_, el) => {
            const $wrapper = $(el);
            const $list = $wrapper.find('.el-images__wrapper');
            if (!$list.length) return;
            if ($list.hasClass('slick-initialized')) return;

            const settings = this.getSettingsFromData($wrapper);

            const reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
            if (reduceMotion) {
                settings.autoplay = false;
                settings.speed = 300;
                settings.cssEase = 'ease';
                settings.pauseOnHover = true;
                settings.pauseOnFocus = true;
                settings.swipe = true;
                settings.draggable = true;
                settings.touchMove = true;
            }

            $list.slick(settings);

            if (settings._marqueeTicker) {
                // Button sicher erstellen (damit er nicht "verschwindet")
                const $btn = this.ensurePauseButton($wrapper);

                // Marquee-Ticker starten + Toggle anbinden
                this.bindMarqueeTicker($list, $wrapper, $btn);
            }
        });
    }

    getSettingsFromData($wrapper) {
        const typ = (this.readData($wrapper, ['slide-typ']) || '').toString().toLowerCase();
        const marqueeStop = this.readData($wrapper, ['marquee-stop']); // "exact"

        const rawAutoplay = this.readData($wrapper, ['slide-autoplay']);
        const rawSpeed = this.readData($wrapper, ['slide-speed']);
        const rawAutoplaySpeed = this.readData($wrapper, ['slide-autoplaySpeed', 'slide-autoplayspeed', 'slide-autoplay-speed']);
        const rawSlides = this.readData($wrapper, ['slides', 'slide-slides']);

        const autoplay = (rawAutoplay === true || rawAutoplay === 'true') ? true : this.options.autoplay;

        const speed = parseInt(rawSpeed, 10);
        const autoplaySpeed = parseInt(rawAutoplaySpeed, 10);
        const slidesToShow = parseInt(rawSlides, 10);

        const out = Object.assign({}, this.options, {
            autoplay,
            speed: Number.isFinite(speed) ? speed : this.options.speed,
            autoplaySpeed: Number.isFinite(autoplaySpeed) ? autoplaySpeed : this.options.autoplaySpeed,
            slidesToShow: Number.isFinite(slidesToShow) ? slidesToShow : this.options.slidesToShow
        });

        // Marquee: Slick nur fürs Layout/Clones, Bewegung machen wir selbst
        if (typ === 'marquee') {
            out.autoplay = false;
            out.autoplaySpeed = 0;
            out.speed = 300;     // nicht 0, Slick ist damit zuverlässiger
            out.cssEase = 'linear';
            out.infinite = true;

            out.pauseOnHover = false;
            out.pauseOnFocus = false;
            out.pauseOnDotsHover = false;

            out.swipe = false;
            out.draggable = false;
            out.touchMove = false;

            if (marqueeStop === 'exact' || marqueeStop === true || marqueeStop === 'true') {
                out._marqueeTicker = true;
            }
        }

        return out;
    }

    ensurePauseButton($wrapper) {
        // falls er schon existiert -> nutzen
        let $btn = $wrapper.find('.slick-autoplay-toggle-button').first();
        if ($btn.length) return $btn;

        // exakt dein Markup
        const html = `
<button type="button" class="slick-autoplay-toggle-button" aria-pressed="false">
  <span class="slick-pause-icon" aria-hidden="true"></span>
  <span class="slick-play-icon" aria-hidden="true" style="display: none;"></span>
  <span class="slick-pause-text slick-sr-only">Pause</span>
  <span class="slick-play-text slick-sr-only" style="display: none">Play</span>
</button>`;

        // wohin damit? in den Wrapper, idealerweise neben/über der List
        // -> du hast .el-images__wrapper im Markup
        const $target = $wrapper.find('.el-images__wrapper').first();
        if ($target.length) {
            $target.prepend(html);
            $btn = $target.find('.slick-autoplay-toggle-button').first();
        } else {
            $wrapper.prepend(html);
            $btn = $wrapper.find('.slick-autoplay-toggle-button').first();
        }

        return $btn;
    }

    bindMarqueeTicker($list, $wrapper, $btn) {
        const $track = $list.find('.slick-track');
        if (!$track.length) return;

        const reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (reduceMotion) return;

        const rawPps = parseFloat(this.readData($wrapper, ['marquee-pps', 'marqueePps']));
        const pps = Number.isFinite(rawPps) ? rawPps : 35;

        const dir = (this.readData($wrapper, ['marquee-dir', 'marquee-direction']) || 'rtl').toString().toLowerCase();
        const sign = (dir === 'ltr') ? 1 : -1;

        const $pauseIcon = $btn.find('.slick-pause-icon');
        const $playIcon  = $btn.find('.slick-play-icon');
        const $pauseText = $btn.find('.slick-pause-text');
        const $playText  = $btn.find('.slick-play-text');

        let rafId = null;
        let lastTs = null;
        let offsetX = 0;
        let paused = false;

        const getLoopWidth = () => {
            // dupliziertes Markup => halbe Trackbreite = 1 Loop
            const w = $track[0].scrollWidth || $track.width();
            return w ? (w / 2) : 0;
        };

        const apply = () => {
            $track.css({
                transition: 'none',
                willChange: 'transform',
                transform: `translate3d(${offsetX}px,0,0)`
            });
        };

        const setUiPaused = (isPaused) => {
            $pauseIcon.css('display', isPaused ? 'none' : '');
            $playIcon.css('display',  isPaused ? '' : 'none');
            $pauseText.css('display', isPaused ? 'none' : '');
            $playText.css('display',  isPaused ? '' : 'none');
            $btn.attr('aria-pressed', isPaused ? 'true' : 'false');
        };

        const tick = (ts) => {
            if (paused) return;
            if (lastTs == null) lastTs = ts;

            const dt = (ts - lastTs) / 1000;
            lastTs = ts;

            offsetX += sign * (pps * dt);

            const loopW = getLoopWidth();
            if (loopW > 0) {
                while (offsetX <= -loopW) offsetX += loopW;
                while (offsetX > 0) offsetX -= loopW;
            }

            apply();
            rafId = requestAnimationFrame(tick);
        };

        const play = () => {
            paused = false;
            lastTs = null;
            if (!rafId) rafId = requestAnimationFrame(tick);
            setUiPaused(false);
        };

        const pause = () => {
            paused = true;
            if (rafId) cancelAnimationFrame(rafId);
            rafId = null;
            lastTs = null;
            apply(); // pixelgenau einfrieren
            setUiPaused(true);
        };

        // Start
        setUiPaused(false);
        play();

        // Button Toggle (nur dieser!)
        $btn.off('click.sliderMarqueeExact').on('click.sliderMarqueeExact', (e) => {
            e.preventDefault();
            const isPaused = $btn.attr('aria-pressed') === 'true';
            if (isPaused) play();
            else pause();
        });

        // Reflow/Resize stabil halten
        $list.off('setPosition.sliderMarqueeExact').on('setPosition.sliderMarqueeExact', () => apply());
        $(window).off('resize.sliderMarqueeExact').on('resize.sliderMarqueeExact', () => apply());
    }

    readData($el, keys = []) {
        for (const key of keys) {
            const val = $el.data(key);
            if (val !== undefined) return val;
        }
        for (const key of keys) {
            const attr = $el.attr('data-' + key);
            if (attr !== undefined) return attr;
        }
        return undefined;
    }
}